import { defineProperty as _defineProperty, inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { FormControl } from './FormControl.js';
import { CheckboxControl } from './CheckboxControl.js';
import { CheckboxGroup } from 'react-checkbox-group';
import { i18n } from '../../../i18n/translate.js';
import kebabCase from 'lodash/kebabCase.js';
import { simpleArrayMatch } from '../../../utils/simpleArrayMatch.js';
import { Stack } from '@chakra-ui/react';
var CheckboxGroupControl = /*#__PURE__*/function (_FormControl) {
  function CheckboxGroupControl(props) {
    var _this;
    _classCallCheck(this, CheckboxGroupControl);
    _this = _callSuper(this, CheckboxGroupControl, [props]);
    _defineProperty(_this, "checkboxChange", function (value, checked) {
      var newValue = _this.state.value.slice(0);
      var valIndex = _this.state.value.findIndex(function (val) {
        return val === value;
      });
      if (checked && valIndex < 0) {
        newValue.push(value);
      } else if (!checked && valIndex >= 0) {
        newValue.splice(valIndex, 1);
      }
      _this.syncData(newValue);
    });
    _defineProperty(_this, "syncData", function (newValue, skipValueChange) {
      if (!simpleArrayMatch(newValue || [], _this.state.value)) {
        _this.setState({
          value: newValue
        }, function () {
          if (typeof _this.props.onValueChange === 'function') {
            _this.props.onValueChange(_defineProperty({}, _this.props.name, newValue));
          }
          if (typeof _this.props.onChange === 'function') {
            _this.props.onChange(newValue, skipValueChange);
          }
          _this.checkError();
        });
      }
    });
    _defineProperty(_this, "toggleShowMore", function () {
      _this.setState({
        showMoreValues: !_this.state.showMoreValues
      });
    });
    _defineProperty(_this, "isValid", function () {
      return !_this.props.required || _this.state.value.length;
    });
    _defineProperty(_this, "renderCheckbox", function (listItem) {
      var _this$props = _this.props,
        CheckboxComponent = _this$props.CheckboxComponent,
        inline = _this$props.inline,
        labelFunction = _this$props.labelFunction,
        labelKey = _this$props.labelKey,
        readOnlyList = _this$props.readOnlyList;
      var itemValue = listItem[_this.props.valueKey];
      var isSelected = _this.state.value.includes(itemValue);
      return /*#__PURE__*/React.createElement(Stack, {
        direction: inline ? 'row' : 'column',
        spacing: "2"
      }, /*#__PURE__*/React.createElement(CheckboxComponent, {
        name: itemValue,
        key: itemValue,
        "data-object-action": _this.props.dataObjectAction || "check-".concat(kebabCase(listItem[labelKey])),
        "data-object-attribute": _this.props.dataObjectAttribute,
        "data-object-id": itemValue,
        "data-object-type": _this.props.dataObjectType,
        valueOverride: _this.props.valueOverride,
        checkboxValue: _this.props.useCheckboxValue ? itemValue : undefined,
        label: listItem[labelKey],
        dataValue: isSelected,
        className: isSelected ? _this.props.selectedClassName : null,
        onChange: function onChange(checked) {
          return _this.checkboxChange(itemValue, checked);
        },
        disabled: _this.props.disabled || readOnlyList && readOnlyList.includes(itemValue),
        id: _this.props.id,
        inline: _this.props.inline
      }, typeof labelFunction === 'function' ? labelFunction(listItem) : null));
    });
    _this.state = {
      showMoreValues: props.truncateSize ? false : true,
      value: props.dataValue || []
    };
    return _this;
  }
  _inherits(CheckboxGroupControl, _FormControl);
  return _createClass(CheckboxGroupControl, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.valueOverride && prevProps.dataValue !== this.props.dataValue) {
        this.syncData(this.props.dataValue || [], true);
      }
    }
  }, {
    key: "checkError",
    value: function checkError() {
      var message = !this.isValid() ? i18n.t('This field is required. Please select at least one option') : null;
      if (typeof this.props.setError === 'function') {
        this.props.setError(!this.isValid(), message);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        _this$props2$valueLis = _this$props2.valueList,
        valueList = _this$props2$valueLis === undefined ? [] : _this$props2$valueLis,
        name = _this$props2.name,
        truncateSize = _this$props2.truncateSize,
        readOnlyList = _this$props2.readOnlyList;
      var readOnlySelected = readOnlyList && readOnlyList.filter(function (readOnly) {
        return _this2.state.value.includes(readOnly);
      });
      var truncatedData = truncateSize ? valueList.slice(0, truncateSize) : valueList;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CheckboxGroup, {
        name: name,
        onChange: this.onChange,
        value: this.state.value,
        className: "checkbox-group ".concat(this.props.className || '')
      }, this.state.showMoreValues || valueList.length <= truncateSize ? valueList.map(this.renderCheckbox) : truncatedData.map(this.renderCheckbox), truncateSize < valueList.length ? /*#__PURE__*/React.createElement("div", {
        className: "show-more-link"
      }, /*#__PURE__*/React.createElement("a", {
        onClick: this.toggleShowMore
      }, this.state.showMoreValues ? i18n.t('Show Less') : i18n.t('Show More'))) : null), readOnlySelected && readOnlySelected.map(function (val) {
        return /*#__PURE__*/React.createElement("input", {
          type: "hidden",
          name: name,
          value: val
        });
      }));
    }
  }]);
}(FormControl);
_defineProperty(CheckboxGroupControl, "propTypes", {
  CheckboxComponent: PropTypes.func,
  className: PropTypes.string,
  dataObjectAction: PropTypes.string,
  dataObjectAttribute: PropTypes.string,
  dataObjectId: PropTypes.string,
  dataObjectType: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  inline: PropTypes.bool,
  labelFunction: PropTypes.func,
  labelKey: PropTypes.string.isRequired,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onValueChange: PropTypes.func,
  readOnlyList: PropTypes.array,
  required: PropTypes.bool,
  selectedClassName: PropTypes.string,
  valueList: PropTypes.array.isRequired,
  valueKey: PropTypes.string.isRequired,
  truncateSize: PropTypes.number
});
_defineProperty(CheckboxGroupControl, "defaultProps", Object.assign({}, FormControl.defaultProps, {
  CheckboxComponent: CheckboxControl
}));
CheckboxGroupControl.displayName = "CheckboxGroupControl";
export { CheckboxGroupControl };